<!-- Two-column layout: Map | Table -->
<div
  class="map-table-layout map-border"
  [class.is-collapsed]="!isTableOpen"
  [style.width]="width"
  [style.height]="height"
>
  <!-- Map column -->
  <div class="map-container">
    <div #map class="map" aria-label="HERE map"></div>

    <!-- Zoom controls: anchored to the map’s top-left inside map-container -->
    <div class="zoom-controls" role="group" aria-label="Map zoom controls">
      <button
        class="zoom-btn"
        type="button"
        aria-label="Zoom in"
        (click)="zoomIn()"
      >
        +
      </button>
      <button
        class="zoom-btn"
        type="button"
        aria-label="Zoom out"
        (click)="zoomOut()"
      >
        -
      </button>
    </div>
  </div>

  <!-- Mobile list (cards) -->
  @if (isMobile) {
    <div class="mobile-list" [class.collapsed]="!isTableOpen">
      <header class="mobile-list__header">
        <div class="handle" aria-hidden="true" (click)="toggleTable()"></div>
        <h3>Locations ({{ markerPoints?.length ?? 0 }})</h3>
      </header>

      <div class="mobile-list__body">
        @if (markerPoints?.length) {
          @for (p of markerPoints; let i = $index; track $index) {
            <button
              class="mobile-card"
              [class.selected]="selectedIndex === i"
              (click)="onRowClick(i)"
              (mouseenter)="onRowEnter(i)"
              (mouseleave)="onRowLeave(i)"
            >
              <div class="mobile-card__body">
                <div class="title">
                  {{ p.data?.name ?? 'Transload facility' }}
                </div>
                <div class="meta">{{ p.data?.address ?? '' }}</div>
              </div>
              <div class="mobile-card__icon">
                <img
                  [src]="p.data?.isLoup ? loupMarker : normalMarker"
                  alt=""
                  width="22"
                  height="22"
                  (error)="onIconError($event)"
                />
              </div>
            </button>
          }
        } @else {
          <div class="mobile-empty">No locations</div>
        }
      </div>
    </div>
  } @else {
    <!-- Right fixed table -->
    <aside class="side-table" [attr.aria-hidden]="!isTableOpen">
      <div class="side-table__header">
        <h3>
          Locations (
          @if (markerPoints) { {{ markerPoints.length }} } @else { 0 }
          )
        </h3>
      </div>

      <div class="side-table__head">
        <div>Details</div>
      </div>

      <div class="side-table__body">
        @if (markerPoints?.length) {
          @for (p of markerPoints; let i = $index; track $index) {
            <button
              class="side-row"
              [class.selected]="i === selectedIndex"
              (click)="onRowClick(i)"
              (mouseenter)="onRowEnter(i)"
              (mouseleave)="onRowLeave(i)"
              title="Focus & show details"
            >
              <div class="col--name">
                <img
                  class="partner-icon"
                  [src]="p.data?.isLoup ? loupMarker : normalMarker"
                  [alt]="p.data?.isLoup ? 'LOUP' : 'Loup Network Partner'"
                  width="18"
                  height="18"
                  loading="lazy"
                  decoding="async"
                  (error)="onIconError($event)"
                />
                <div>
                  <div class="name-text">
                    {{ p.data?.name || 'Location' }}
                  </div>
                  @if (p.data?.address) {
                    <div class="subtext">· {{ p.data?.address }}</div>
                  }
                </div>
              </div>
            </button>
          }
        } @else {
          <div class="no-data-available">No locations</div>
        }
      </div>
    </aside>

    <!-- Collapse / Expand toggle (floats near the divider) -->
    <button
      class="panel-toggle"
      type="button"
      [attr.aria-expanded]="isTableOpen"
      aria-controls="locations-panel"
      (click)="toggleTable()"
      (keydown.enter)="toggleTable()"
      (keydown.space)="toggleTable(); $event.preventDefault()"
    >
      <span class="panel-toggle__icon" [class.rot]="!isTableOpen">❮❯</span>
      <span class="sr-only">
        {{ isTableOpen ? 'Collapse list' : 'Expand list' }}
      </span>
    </button>
  }
</div>